export const MENTION = 'mention';
